import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SiteCtx = createContext(null);

export const telHref = (phone, scheme = "tel") => {
  const d = (phone || "").replace(/\D/g, "");
  return `${scheme}:${d.length === 10 ? `+1${d}` : d}`;
};

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setSite(r.data)).catch(() => setFailed(true));
  }, []);

  if (failed) return <div className="grid min-h-screen place-items-center p-6 text-center" data-testid="site-load-error">Sorry, the site didn't load. Please refresh the page.</div>;
  if (!site) return <div className="min-h-screen bg-[#FFF4F8]" data-testid="site-loading" />;
  return <SiteCtx.Provider value={{ site, setSite }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
